import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ModelMarket from './pages/ModelMarket';
import Workbook from './pages/Workbook';
import ProductIntro from './pages/ProductIntro';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/market" element={<ModelMarket />} />
        <Route path="/workbook" element={<Workbook />} />
        <Route path="/product" element={<ProductIntro />} />
      </Routes>
    </HashRouter>
  </React.StrictMode>,
);
